<template>
  <div>
    <draggable v-model="fileList" @change="change">
      <transition-group>
        <div v-for="(item, index) in fileList" :key="index" class="draggable-item" style="width: 146px; height: 146px; float: left">
          <el-image :src="item.url"></el-image>

          <span class="shadow">
            <div class="spanIcon">
              <el-col :span="12">
                <span @click="onPreview(item)">
                  <i class="el-icon-zoom-in"></i>
                </span>
              </el-col>
              <el-col :span="12">
                <span @click="onRemove(item)">
                  <i class="el-icon-delete"></i>
                </span>
              </el-col>
            </div>
            <div class="spanInfo">
              <el-col>
                <span>
                  {{ item.name }}
                </span>
              </el-col>
            </div>
          </span>
        </div>
      </transition-group>
    </draggable>
    <el-upload action multiple :on-preview="onPreview" :on-remove="onRemove" :before-upload="beforeUpload" :file-list="fileList" :show-file-list="false" accept="image/*">
      <i class="el-icon-plus uploadIcon" style="width: 146px; height: 146px"></i>
    </el-upload>
    <div class="suggest-size">
      {{ uploadsize }}
    </div>
    <el-dialog :visible.sync="dialogVisible" :append-to-body="true">
      <img width="100%" :src="dialogImage" alt />
    </el-dialog>
  </div>
</template>
<style>
.file-image {
  width: 100%;
  height: 100%;
  background-size: cover;
}
.uploadIcon {
  width: 100%;
  height: 100%;
  position: relative;
  display: flex;
  align-items: center;
  justify-content: center;
  border: 1px dashed #c0ccda;
  background-color: #fbfdff;
  border-radius: 6px;
  font-size: 20px;
  color: #999;
}
.draggable-item {
  margin-right: 5px;
  margin-bottom: 5px;
  border: 1px solid #ddd;
  border-radius: 6px;
  position: relative;
  overflow: hidden;
}
.shadow {
  position: absolute;
  width: 100%;
  height: 100%;
  left: 0;
  top: 0;
  cursor: pointer;
  text-align: center;
  color: #fff;
  opacity: 0;
  font-size: 14px;
  background-color: rgba(0, 0, 0, 0.5);
  -webkit-transition: opacity 0.3s;
  transition: opacity 0.3s;
}
.shadow:hover {
  opacity: 1;
}
.spanIcon {
  width: 60%;
  margin: auto;
  margin-top: 15px;
}

.spanInfo {
  width: 80%;
  line-height: 20px !important;
  margin: auto;
  text-align: center;
}
.spanIcon {
  font-size: 20px;
  text-align: center;
  color: #fff;
  opacity: 1;
  font-size: 20px;
}
.suggest-size {
  height: 12px;
  line-height: 12px;
  display: block;
  font-size: 12px;
  color: #606266;
  margin-top: 7px;
}
</style>
<script>
import draggable from "vuedraggable";
export default {
  props: ["value", "path", "uploadsize"],
  components: {
    draggable,
  },
  data() {
    return {
      dialogImage: "",
      dialogVisible: false,
      fileList: [],
      valueList: [],
    };
  },
  created() {
    if (!this.value) return;
    var l = JSON.parse(this.value);

    l.forEach((x) => {
      this.fileList.push({ url: x.url, name: x.name });
    });
  },
  methods: {
    onRemove(file, fileList) {
      this.fileList.forEach((x, i, arr) => {
        if (x.url == file.url) {
          arr.splice(i, 1);
        }
      });

      var l = [];
      this.fileList.forEach((x) => {
        l.push({ url: x.url, name: x.name });
      });
      this.$emit("input", JSON.stringify(l));
    },
    onPreview(file) {
      //点击显示
      this.dialogVisible = true;
      this.dialogImage = file.url;
    },
    beforeUpload(file) {
      this.Data.Tool.Upload(file, this.path || "test").then((res) => {
        this.fileList.push({ url: res.data, name: file.name });
        var l = [];
        this.fileList.forEach((x) => {
          l.push({ url: x.url, name: x.name });
        });
        this.$emit("input", JSON.stringify(l));
      });
      return false;
    },

    change(evt) {
      this.$emit("input", JSON.stringify(this.fileList));
    },
  },
};
</script>